import { cn } from '@ifixit/ui/lib/utils';
import type { ComponentProps } from 'react';

function Input({ className, type, autoComplete, ...props }: ComponentProps<'input'>) {
   // Provide sensible autocomplete defaults based on input type
   const defaultAutoComplete = autoComplete ?? (type === 'email' ? 'email' : undefined);

   return (
      <input
         type={type}
         autoComplete={defaultAutoComplete}
         data-slot="input"
         className={cn(
            'file:text-foreground placeholder:text-muted-foreground selection:bg-primary-fill selection:text-primary-foreground border-input flex h-9 w-full min-w-0 rounded-lg border bg-card px-3 py-1 text-base transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:pointer-fine:text-sm/9',
            'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
            'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
            className
         )}
         {...props}
      />
   );
}

export { Input };
